// Schema type utilities
function createVersionPredicate(expectedVersion) {
    return (projectSchema) => {
        let { schemaVersion } = projectSchema;
        if (!schemaVersion || schemaVersion === '1') {
            schemaVersion = '1.0.0';
        }
        if (schemaVersion === '3') {
            schemaVersion = '3.0.0';
        }
        return Boolean(expectedVersion && schemaVersion && expectedVersion === schemaVersion);
    };
}
export const isProjectSchemaJSONV1_0_0 = createVersionPredicate('1.0.0');
export const isProjectSchemaJSONV3_0_0 = createVersionPredicate('3.0.0');
export const isProjectSchemaJSONV3_1_0 = createVersionPredicate('3.1.0');
export const isProjectSchemaJSONV3_2_0 = createVersionPredicate('3.2.0');
export const isProjectSchemaJSONV3_3_0 = createVersionPredicate('3.3.0');
export const isProjectSchemaJSONV3_4_0 = createVersionPredicate('3.4.0');
export const isProjectSchemaJSONV3_5_0 = createVersionPredicate('3.5.0');
export const isProjectSchemaJSONV3_5_1 = createVersionPredicate('3.5.1');
export const isProjectSchemaJSONV3_6_0 = createVersionPredicate('3.6.0');
export const isProjectSchemaJSONV3_7_0 = createVersionPredicate('3.7.0');
export const isProjectSchemaJSONV3_8_0 = createVersionPredicate('3.8.0');
export const isProjectSchemaJSONV3_9_0 = createVersionPredicate('3.9.0');
export const isProjectSchemaJSONV3_10_0 = createVersionPredicate('3.10.0');
export const isProjectSchemaJSONV3_11_0 = createVersionPredicate('3.11.0');
export const isProjectSchemaJSONV3_12_0 = createVersionPredicate('3.12.0');
export const isProjectSchemaJSONV3_12_1 = createVersionPredicate('3.12.1');
export const isProjectSchemaJSONV3_12_2 = createVersionPredicate('3.12.2');
export const isProjectSchemaJSONV3_12_3 = createVersionPredicate('3.12.3');
export const isProjectSchemaJSONV3_13_0 = createVersionPredicate('3.13.0');
export const isProjectSchemaJSONV3_14_0 = createVersionPredicate('3.14.0');
export const isProjectSchemaJSONV3_15_0 = createVersionPredicate('3.15.0');
export const isProjectSchemaJSONV3_16_0 = createVersionPredicate('3.16.0');
export const isProjectSchemaJSONV3_17_0 = createVersionPredicate('3.17.0');
export const isProjectSchemaJSONV3_17_1 = createVersionPredicate('3.17.1');
export const isProjectSchemaJSONV3_18_0 = createVersionPredicate('3.18.0');
export const isProjectSchemaJSONV3_18_1 = createVersionPredicate('3.18.1');
export const isProjectSchemaJSONV3_18_2 = createVersionPredicate('3.18.2');
export const isProjectSchemaJSONV3_19_0 = createVersionPredicate('3.19.0');
export const isProjectSchemaJSONV3_20_0 = createVersionPredicate('3.20.0');
export const isProjectSchemaJSONV3_21_0 = createVersionPredicate('3.21.0');
export const isProjectSchemaJSONV3_22_0 = createVersionPredicate('3.22.0');
export const isProjectSchemaJSONV3_23_0 = createVersionPredicate('3.23.0');
export const isProjectSchemaJSONV3_24_0 = createVersionPredicate('3.24.0');
export const isProjectSchemaJSONV3_25_0 = createVersionPredicate('3.25.0');
export const isProjectSchemaJSONV3_26_0 = createVersionPredicate('3.26.0');
export const isProjectSchemaJSONV3_27_0 = createVersionPredicate('3.27.0');
export const isProjectSchemaJSONV3_28_0 = createVersionPredicate('3.28.0');
export const isProjectSchemaJSONV3_29_0 = createVersionPredicate('3.29.0');
export const isProjectSchemaJSONV3_30_0 = createVersionPredicate('3.30.0');
export const isProjectSchemaJSONV3_31_0 = createVersionPredicate('3.31.0');
export const isProjectSchemaJSONV3_32_0 = createVersionPredicate('3.32.0');
export const isProjectSchemaJSONV3_33_0 = createVersionPredicate('3.33.0');
export const isProjectSchemaJSONV3_34_0 = createVersionPredicate('3.34.0');
export const isProjectSchemaJSONV3_35_0 = createVersionPredicate('3.35.0');
export const isProjectSchemaJSONV3_36_0 = createVersionPredicate('3.36.0');
export const isProjectSchemaJSONV3_37_0 = createVersionPredicate('3.37.0');
export const isProjectSchemaJSONV3_38_0 = createVersionPredicate('3.38.0');
export const isProjectSchemaJSONV3_39_0 = createVersionPredicate('3.39.0');
export const isProjectSchemaJSONV3_40_0 = createVersionPredicate('3.40.0');
export const isProjectSchemaJSONV3_41_0 = createVersionPredicate('3.41.0');
export const isProjectSchemaJSONV3_42_0 = createVersionPredicate('3.42.0');
export const isProjectSchemaJSONV3_43_0 = createVersionPredicate('3.43.0');
export const isProjectSchemaJSONV3_44_0 = createVersionPredicate('3.44.0');
export const isProjectSchemaJSONV3_45_0 = createVersionPredicate('3.45.0');
export const isProjectSchemaJSONV3_46_0 = createVersionPredicate('3.46.0');
export const isProjectSchemaJSONV3_47_0 = createVersionPredicate('3.47.0');
export const isProjectSchemaJSONV3_48_0 = createVersionPredicate('3.48.0');
export const isProjectSchemaJSONV3_49_0 = createVersionPredicate('3.49.0');
export const isProjectSchemaJSONV3_50_0 = createVersionPredicate('3.50.0');
export const isProjectSchemaJSONV3_51_0 = createVersionPredicate('3.51.0');
export const isProjectSchemaJSONV3_52_0 = createVersionPredicate('3.52.0');
export const isProjectSchemaJSONV3_53_0 = createVersionPredicate('3.53.0');
export const isProjectSchemaJSONV3_54_0 = createVersionPredicate('3.54.0');
export const isProjectSchemaJSONV3_55_0 = createVersionPredicate('3.55.0');
export const isProjectSchemaJSONV3_56_0 = createVersionPredicate('3.56.0');
export const isProjectSchemaJSONV3_57_0 = createVersionPredicate('3.57.0');
export const isProjectSchemaJSONV3_58_0 = createVersionPredicate('3.58.0');
export const isProjectSchemaJSONV3_59_0 = createVersionPredicate('3.59.0');
export const isLatestProjectSchemaJSON = createVersionPredicate('3.59.0');
export const isProjectSchemaJSONV4_0_0 = createVersionPredicate('4.0.0');
